import Main from './Main'
import Lista from './components/OrigemContatoLista'
import Novo from './components/NovaOrigemContato'

export default [
  {
    path: 'origem-contato',
    name: 'policiacivil.processo.origem-contato',
    component: Main,
    redirect: { name: 'policiacivil.processo.origem-contato.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.origem-contato.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.origem-contato.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.origem-contato.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/origem-contato/routes.js